import script from "./categories-index.vue?vue&type=script&setup=true&lang=js"
export * from "./categories-index.vue?vue&type=script&setup=true&lang=js"

import "./categories-index.vue?vue&type=style&index=0&id=f670adba&lang=css"

const __exports__ = script;

export default __exports__